module.exports = "mutation DeleteAllianceCustomerContact($id:ID!){deleteAllianceCustomerContact(id:$id){success}}"